import { render, staticRenderFns } from "./AIBriefGenerator.vue?vue&type=template&id=7143e80a&scoped=true"
import script from "./AIBriefGenerator.vue?vue&type=script&lang=js"
export * from "./AIBriefGenerator.vue?vue&type=script&lang=js"
import style0 from "./AIBriefGenerator.vue?vue&type=style&index=0&id=7143e80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7143e80a",
  null
  
)

export default component.exports